<template>
  <div>
    <modal name="configureSchedulerModal" class="custom-modal" :width="'75%'" :height="'auto'"
           :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose"
           :clickToClose="true">
      <div :class="{'isLoading': isLoading, 'noDisplay': !isLoading}" class="overlay">
        <div class="spinner-align">
          <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
        </div>
      </div>
      <div v-if="!isLoading" class="modal-padding" @click="onSave">
        <div class="page-title">

          <div class="col-md-6 noPaddingLeft">
            <span class="h2-text">{{configurations.clientName}}'s - Configure Scheduler</span>
          </div>

          <div class="col-md-6 noPaddingRight align-right-item">
          <span class="modal-close-img" @click="hideModal">
            <span class="icon-close"></span>
          </span>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-6">
            <button v-on:click="handleOpenSchedulerPreview()" class="ap-btn secondary">Preview Scheduler</button>
          </div>

          <div class="col-md-3">
            <div class="float-right">
              <Toggle v-model="configurations.live" :text="'Online Scheduler'"/>
            </div>
          </div>

          <div class="col-md-3">
            <div class="float-right">
              <Toggle v-model="configurations.liveTestUser" :text="'Online Scheduler for Test Accounts'"/>
            </div>
          </div>
        </div>

        <div class="scheduler mt-4">
          <div class="row">
            <div class="col text-entry-field-wrapper">
              <span class="text-entry-title">Scheduler name</span>
              <input class="text-input" v-model="configurations.name" placeholder="Enter your scheduler name" />
            </div>
            <div class="col text-entry-field-wrapper">
              <div class="row">
                <div class="col text-entry-field-wrapper">
                  <span class="text-entry-title">URL Hyperlink Color</span>
                  <input class="text-input" v-model="configurations.urlHyperlinkColor" placeholder="Enter a HEX code"/>
                </div>
                <div class="col text-entry-field-wrapper">
                  <span class="text-entry-title">Branded URL</span>
                  <input class="text-input" v-model="configurations.brandedURL" v-validate="'required|url:require_protocol'" name="brandedURL" placeholder="Branded URL"/>
                  <div class="branded-url-error">
                    <div v-if="errors.has('brandedURL')" class="alert-icon-red-error"></div>
                    <div class="error-text-color">{{ errors.first('brandedURL') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3 flex-column align-items-end">
            <div class="col-md-6 text-entry-field-wrapper">
              <span class="text-entry-title">ShiftBoard Lead WorkGroup</span>
              <multiselect v-model="dropdowntitle"
                           :options="allWorkGroups"
                           placeholder="Choose Lead WorkGroup"
                           label="name"
                           class="multiple-select-work-group"
                           :openDirection="'below'"
                           :multiple="false"
                           :close-on-select="true"
                           :hide-selected="true"
                           track-by="id"
                           :allow-empty="false"
                           :show-labels="false"
                           @select="dropdownItemClick"
                           :disabled="false">
              </multiselect>
              <span class="text-entry-title">ShiftBoard Screener WorkGroup</span>
              <multiselect v-model="screenerDropdowntitle"
                           :options="allWorkGroups"
                           placeholder="Choose Screener WorkGroup"
                           label="name"
                           class="multiple-select-work-group"
                           :openDirection="'below'"
                           :multiple="false"
                           :close-on-select="true"
                           :hide-selected="true"
                           track-by="id"
                           :allow-empty="false"
                           :show-labels="false"
                           @select="screenerDropdownItemClick"
                           :disabled="false">
              </multiselect>
              <span class="text-entry-title">ShiftBoard Phlebotomist WorkGroup</span>
              <multiselect v-model="phlebotomistDropdowntitle"
                           :options="allWorkGroups"
                           placeholder="Choose Phlebotomist WorkGroup"
                           label="name"
                           class="multiple-select-work-group"
                           :openDirection="'below'"
                           :multiple="false"
                           :close-on-select="true"
                           :hide-selected="true"
                           track-by="id"
                           :allow-empty="false"
                           :show-labels="false"
                           @select="phlebotomistDropdownItemClick"
                           :disabled="false">
              </multiselect>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-entry-field-wrapper">
              <span class="text-entry-title">Landing Page Top Text</span>
              <vue-ckeditor
                v-model="configurations.landingTopText"
                :config="config" ></vue-ckeditor>
            </div>
            <div class="col text-entry-field-wrapper">
              <span class="text-entry-title">Landing Page Bottom Text</span>
              <vue-ckeditor
                v-model="configurations.landingBottomText"
                :config="config" ></vue-ckeditor>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-entry-field-wrapper">
              <span class="text-entry-title">Thank you page text</span>
              <vue-ckeditor
                v-model="configurations.landingThankYouText"
                :config="config" ></vue-ckeditor>
            </div>
            <div class="col"></div>
          </div>
        </div>

        <hr class="mt-4 mb-4">

        <!-- Configurations -->
        <div class="configurations">
          <div class="title">Configurations</div>

          <div class="row mt-3">
            <div class="col-md-4">
              <Toggle v-model="configurations.allowWithoutLimeade" :text="'Allow walk-ins'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.allowBookForSpouse" :text="'Spouse appointment'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.allowSendParticipantSurvey" :text="'Participant Survey'"/>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-entry-field-wrapper">
              <Toggle v-model="configurations.allowBookFluShot" :text="'Vaccine Appointment (Flu shots/Covid Vaccines)'" :disabled="!enableBookVaccineAtClient"/>
            </div>
            <div class="col-md-4 text-entry-field-wrapper">
              <div>
                <div class="text-entry-title display-flex-end" :class="{'opacity-06': !configurations.allowBookForSpouse}">
                  <span>Spouse Label</span>
                  <span :class="{'noDisplay': !configurations.allowBookForSpouse}" class="display-space-between">
                  <span v-if="errors.has('spouse')" class="alert-icon-red-error"></span>
                  <span class="error-text-color">{{ errors.first('Spouse') }}</span>
                </span>
                </div>
                <input class="text-input" v-model="configurations.spouseLabel" :disabled="!configurations.allowBookForSpouse"
                       :class="{'opacity-06': !configurations.allowBookForSpouse}"
                       v-validate="'required'"
                       name="Spouse"
                       placeholder="Enter Spouse Label"/>
              </div>
            </div>
            <div class="col-md-4 text-entry-field-wrapper">
              <span :class="{'opacity-06': !configurations.allowSendParticipantSurvey}"
                    class="text-entry-title">Biometrics Survey URL</span>

              <input class="text-input" v-model="configurations.surveyBiometricResultUrl"
                     value="configurations.surveyBiometricResultUrl"
                     :class="{'opacity-06': !configurations.allowSendParticipantSurvey}"
                     :disabled="!configurations.allowSendParticipantSurvey"
                     placeholder="Enter Biometrics Survey Link"/>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <Toggle v-model="configurations.zendeskConfiguration" :text="'ZenDesk'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.multipleScreeningsPerYear" :text="'Multiple Screenings Per Year'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.enableSMSReminder" :text="'Screening Related SMS'"/>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <Toggle v-model="configurations.hpsf" :text="'HPSF'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.labCorp" :text="'Labcorp'"/>
            </div>
            <div class="col-md-4">
              <Toggle v-model="configurations.htk" :text="'Home Test Kit'"/>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <div class="text-entry-field-wrapper">
                <div class="text-entry-title display-flex-end" :class="{'opacity-06': !configurations.hpsf}">
                  <span>HPSF URL</span>
                  <span :class="{'noDisplay': !configurations.hpsf}" class="display-space-between">
                  <span v-if="errors.has('hpsf')" class="alert-icon-red-error"></span>
                  <span class="error-text-color">{{ errors.first('hpsf') }}</span>
                </span>
                </div>
                <input class="text-input" v-model="configurations.hpsfUrl" :disabled="!configurations.hpsf"
                       :class="{'opacity-06': !configurations.hpsf}"
                       v-validate="'required|url:require_protocol'"
                       name="hpsf"
                       placeholder="Enter HPSF URL"
                />
              </div>
            </div>
            <div class="col-md-4">
            </div>
            <div class="col-md-4">
              <div class="text-entry-field-wrapper">
                <div class="text-entry-title display-flex-end" :class="{'opacity-06': !configurations.htk}">
                  <span>Home Test Kit URL</span>
                  <span :class="{'noDisplay': !configurations.htk}" class="display-space-between">
                  <span v-if="errors.has('htk')" class="alert-icon-red-error"></span>
                  <span class="error-text-color">{{ errors.first('htk') }}</span>
                </span>
                </div>
                <input class="text-input" v-model="configurations.htkUrl" :disabled="!configurations.htk"
                       :class="{'opacity-06': !configurations.htk}"
                       v-validate="'required|url:require_protocol'"
                       name="htk"
                       placeholder="Enter Home Test Kit URL"
                />
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <Toggle v-model="configurations.enableSignupEmail" :text="'SignUp Email'"/>
            </div>
          </div>
        </div>
        <hr class="mt-4 mb-4">
        <div class="participant-emails">
          <span class="title">Participant & Spouse Emails</span>
          <div class="row mt-3">
            <div class="col-md-8 text-entry-field-wrapper">
              <span class="text-entry-title">Participant Email Template</span>
              <multiselect v-model="emailTemplate"
                           :options="configurations.emailTemplateDtoList"
                           placeholder="Choose Email Type"
                           label="templateTypeName"
                           class="multiple-select-work-group"
                           :openDirection="'below'"
                           @select="onSelectTemplate"
                           :allow-empty="false"
                           :show-labels="false"
              >
              </multiselect>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-8 text-entry-field-wrapper">
              <span class="text-entry-title">Subject Line</span>
              <vue-ckeditor
                v-model="emailTemplate.emailSubject"
                :config="configEmail"
                @input="onChangeTemplate"></vue-ckeditor>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-entry-field-wrapper">
              <span class="text-entry-title">Email body</span>
              <vue-ckeditor
                v-model="emailTemplate.body"
                :config="configEmail"
                @input="onChangeTemplate"></vue-ckeditor>
            </div>
          </div>
        </div>
        <div class="margin-top-44px group-btn">
          <button class="ap-btn primary ml-3" id="save-configure-scheduler" @click="onSave" :disabled="isLoading" :class="{'opacity-04': isLoading}">Save</button>
        </div>
      </div>
      <SchedulerPreview/>
    </modal>
    <Popup :name="'saveConfigurationsModal'" :cancel-text="'Cancel'" :submit-text="'Save'" @onSubmit="saveConfigurations">
      <template slot="header">Are you sure to save these configurations?</template>
      <template slot="body">Changing client level shiftboard teams assignment will overwrite all event level shiftboard teams assignments listed under this client.</template>
    </Popup>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {mapActions, mapGetters} from 'vuex';
  import VueSlider from 'vue-slider-component';
  import Multiselect from 'vue-multiselect';
  import Icon from 'vue-awesome/components/Icon';
  import PatientDetailModal from '../../components/modal/patient/PatientDetailModal';
  import ScrollTop from '../../components/utils/ScrollTop';
  import StaffManagement from '../../components/eventManagement/eventDetail/StaffManagement';
  import VueCkeditor from 'vue-ckeditor2';
  import VeeValidate from 'vee-validate';
  import constants from '../../_consts';
  import Toggle from '../commons/Toggle';
  import SchedulerPreview from './preview/SchedulerPreview';
  import cssHelper from '../../utils/css-helper';
  import _ from 'lodash';
  import Popup from '../commons/Popup';

  Vue.use(VeeValidate);

  const dict = {
    custom: {
      hpsf: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      labcorp: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      htk: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      brandedURL: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      }
    }
  };

  export default {
    name: 'configureSchedulerModal',
    components: {
      Toggle,
      VueSlider,
      Icon,
      PatientDetailModal,
      ScrollTop,
      StaffManagement,
      VueCkeditor,
      Multiselect,
      SchedulerPreview,
      Popup
    },
    props: {},
    data () {
      return {
        clientId: 0,
        dropdowntitle: [],
        screenerDropdowntitle: [],
        phlebotomistDropdowntitle: [],
        allWorkGroups: [],
        configurations: {
          allowBookFluShot: false,
          allowBookForSpouse: false,
          confirmationEmailTemplate: {
            body: '',
            emailSubject: null,
            templateType: ''
          },
          cancellationEmailTemplate: {
            body: ''
          },
          reminderEmailTemplate: {
            body: ''
          },
          reminderSpouseEmailTemplate: {
            body: ''
          },
          confirmationSpouseEmailTemplate: {
            body: ''
          },
          cancellationSpouseEmailTemplate: {
            body: ''
          },
          biometricResultEmailTemplate: {
            body: ''
          },
          spouseLabel: '',
          landingTopText: '',
          landingBottomText: '',
          landingThankYouText: '',
          liveTestUser: false
        },
        imageData: '',
        isLoading: false,
        eventSchedulerList: [],
        config: {
          toolbar: [
            { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
            { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'tools', items: [ 'Maximize' ] }
          ],
          height: 300,
          toolbarCanCollapse: true,
          allowedContent: true,
          toolbarStartupExpanded: false
        },
        configEmail: {
          // config for editor of email fields
          toolbar: [
            { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
            { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'tools', items: [ 'Maximize' ] },
            { name: 'Event Fields', items: ['eventTags'] },
            { name: 'document', items: ['Source'] }
          ],
          height: 300,
          fullPage: true, // allow content contains html/body/head tags
          autoGrow_onStartup: true,
          toolbarCanCollapse: true,
          allowedContent: true,
          toolbarStartupExpanded: true,
          extraPlugins: 'eventTags',
          emailTags: []
        },
        cache: {
          configurations: {}
        },
        emailTemplate: {
          body: '',
          emailSubject: '',
          templateType: ''
        },
        enableBookVaccineAtClient: false
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('configureSchedulerModal');
      },
      beforeOpen (params) {
        this.$validator.localize('en', dict); // This is used to overwrite the default error message
        this.clientId = params.params.clientId;

        this.isLoading = true;
        this.actionGetClientSchedulerConfig(this.clientId).then((response) => {
          if (!response.errors) {
            this.configurations = response.configurations || {};
            localStorage.setItem('SchedulerConfigurations', JSON.stringify(this.configurations));
            cssHelper.customColorForUI();
            this.cache.configurations = _.cloneDeep(this.configurations);
            this.imageData = this.configurations.logoFullUrl ? process.env.SOF_API_SERVER_HOST + '/' + this.configurations.logoFullUrl : '';
            this.allWorkGroups = response.sbWorkGroupDtos;
            this.dropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbWorkGroupId);
            this.screenerDropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbScreenerWorkGroupId);
            this.phlebotomistDropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbPhlebotomistWorkGroupId);
            this.emailTemplate = this.configurations.emailTemplateDtoList[0];
            this.actionGetClient(this.clientId).then(clientResponse => {
              let client = clientResponse.data.data;
              if (client && client.addOns && client.addOns.includes(constants.listAdditionalServicesKey.fluShots)) {
                this.enableBookVaccineAtClient = true;
              }
            });
          } else {
            this.$toast.success(response.errors, '', {
              ...this.$toastOpt.optError
            });
          }
        }).finally(() => {
          this.isLoading = false;
        });
      },
      onCancel () {
        this.configurations = _.cloneDeep(this.cache.configurations);
      },
      previewFiles () {
        this.logo = this.$refs.logo.files;
      },
      isUsedBingMap () {
        return localStorage.getItem(constants.LOCAL_STORE.isBingMap) === 'true';
      },
      removeImage: function (e) {
        this.logo = null;
        this.imageData = '';
        this.configurations.logoFullUrl = null;
        this.configurations.logoUrl = null;
        this.configurations.logoThumbFullUrl = null;
      },
      previewImage: function (event) {
        // Reference to the DOM input element
        let input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          if (input.files[0].size > 1020 * 300) {
            // 300KB
            this.$toast.success('File size must be less than 300Kb', '', {
              ...this.$toastOpt.optError
            });
            return;
          }
          // create a new FileReader to read this image and convert to base64 format
          let reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            this.imageData = e.target.result;
          };
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
          this.logo = input.files[0];
        }
      },
      dropdownItemClick (item) {
        this.dropdownTitle = item;
        this.configurations.sbWorkGroupId = item.id;
      },
      screenerDropdownItemClick (item) {
        this.screenerDropdownTitle = item;
        this.configurations.sbScreenerWorkGroupId = item.id;
      },
      phlebotomistDropdownItemClick (item) {
        this.phlebotomistDropdownTitle = item;
        this.configurations.sbPhlebotomistWorkGroupId = item.id;
      },
      preventSave (event) {
        let excludeIds = ['save-configure-scheduler'];
        if (excludeIds.includes(event.target.id)) {
          return false;
        }

        let types = ['input', 'button', 'span', 'label', 'multiselect'];
        if (types.includes(event.target.tagName.toLowerCase())) {
          return true;
        }
        let classes = ['multiselect', 'multiselect__select', 'multiselect__tags', 'cke_path_item', 'cke_combo_button', 'cke_button', 'cke_toolbox_collapser', 'multiselect__select'];
        return classes.find(e => event.target.classList.contains(e));
      },
      async onSave (event) {
        if (this.preventSave(event)) {
          return;
        }

        if (this.isLoading) {
          return;
        }

        if (await this.checkValidFields()) {
          this.$modal.show('saveConfigurationsModal');
        }
      },
      async checkValidFields () {
        // check if HPSF, labcorp or HTK is on, text box must not be empty
        await this.$validator.validate();
        if (this.errors.items.length > 0) {
          if (this.errors.items[0].rule === 'required') {
            this.$toast.success('The field is blank, please enter a URL', '', {
              ...this.$toastOpt.optError
            });
          } else {
            this.$toast.success('Please enter a valid URL', '', {
              ...this.$toastOpt.optError
            });
          }
          return false;
        }
        return true;
      },
      saveConfigurations: async function () {
        this.isLoading = true;
        if (!this.logo || this.isUsedBingMap()) {
          this.actionSaveConfigurations(this.configurations).then((responseSaveConfigs) => {
            if (!responseSaveConfigs.message) {
              this.configurations = responseSaveConfigs.configurations;
              this.cache.configurations = _.cloneDeep(this.configurations);
              this.$toast.success('Saved configurations!', '', {
                ...this.$toastOpt.optSuccess
              });
            } else {
              this.$toast.success(responseSaveConfigs.message, '', {
                ...this.$toastOpt.optError
              });
            }
            this.isLoading = false;
          });
        } else {
          this.actionUploadLogo({clientId: this.clientId, imageFile: this.logo}).then((response) => {
            if (!response.message) {
              this.actionGetClientSchedulerConfig(this.clientId).then((newConfigs) => {
                if (!newConfigs.message) {
                  this.configurations.logoUrl = newConfigs.configurations.logoUrl;
                  this.configurations.logoThumbFullUrl = newConfigs.configurations.logoThumbFullUrl;
                  this.configurations.logoFullUrl = newConfigs.configurations.logoFullUrl;
                  this.actionSaveConfigurations(this.configurations).then((responseSaveConfigs) => {
                    if (!responseSaveConfigs.message) {
                      this.configurations = newConfigs.configurations;
                      this.cache.configurations = _.cloneDeep(this.configurations);
                      this.$toast.success('Saved configurations!', '', {
                        ...this.$toastOpt.optSuccess
                      });
                    } else {
                      this.$toast.success(responseSaveConfigs.message, '', {
                        ...this.$toastOpt.optError
                      });
                    }
                    this.isLoading = false;
                  });
                } else {
                  this.$toast.success(newConfigs.message, '', {
                    ...this.$toastOpt.optError
                  });
                }
                this.isLoading = false;
              });
            } else {
              this.$toast.success(response.message, '', {
                ...this.$toastOpt.optError
              });
            }
            this.isLoading = false;
          });
        }
        localStorage.setItem('SchedulerConfigurations', JSON.stringify(this.configurations));
        cssHelper.customColorForUI();
      },
      updateClientEventSchedulerStatus () {
        this.actionUpdateClientEventSchedulerStatus({
          clientId: this.clientId,
          events: this.eventSchedulerList
        }).then((response) => {
          if (!response.message) {
            this.eventSchedulerList = response.events;
          } else {
            this.$toast.success(response.message, '', {
              ...this.$toastOpt.optError
            });
          }
        });
      },
      handleOpenSchedulerPreview () {
        const config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
        this.$modal.show('schedulerPreviewModal', {
          allowBookFluShot: config.allowBookFluShot,
          allowBookForSpouse: config.allowBookForSpouse,
          spouseLabel: config.spouseLabel,
          landingTopText: config.landingTopText,
          landingBottomText: config.landingBottomText,
          landingThankYouText: config.landingThankYouText
        });
      },
      onSelectTemplate (item) {
        this.emailTemplate = item;
      },
      onChangeTemplate (e) {
        this.configurations.emailTemplateDtoList.forEach((element, index) => {
          if (element.templateType === this.emailTemplate.templateType) {
            this.configurations.emailTemplateDtoList[index] = {
              ...element,
              body: this.emailTemplate.body,
              emailSubject: this.emailTemplate.emailSubject
            };
          }
        });
      },
      ...mapActions({
        actionGetClientSchedulerConfig: 'ACTION_GET_CLIENT_SCHEDULER_CONFIG',
        actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS',
        actionSaveConfigurations: 'ACTION_SAVE_CONFIGURATIONS',
        actionUploadLogo: 'ACTION_UPLOAD_LOGO',
        getClientEventSchedulerStatus: 'ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS',
        actionUpdateClientEventSchedulerStatus: 'ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS',
        actionGetClient: 'ACTION_GET_CLIENT'
      })
    },
    created () {
      this.actionGetEmailTags().then((response) => {
        this.configEmail.emailTags = [];
        for (let tag of response.tags) {
          if (!tag.useResetPassTemplate) {
            this.configEmail.emailTags.push(tag);
          }
        }
      });
    },
    computed: {
      ...mapGetters({
        getIsLoading: 'GETTER_IS_LOADING_MODAL'
      })
    }
  }
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';
@import '../../styles/aduro/_icon.less';

.custom-modal {
  background: rgba(0, 0, 0, 0.4);
  font-family: @font-family-main;
  color: @black-3;

  .modal-padding {
    padding: 24px;
    min-height: 100vh;

    .icon-close {
      display: block;
    }

    .ap-btn {
      text-transform: capitalize;
      padding: 4px 24px;
    }

    .align-right-item {
      text-align: right;
    }

    .page-title{
      display: flex;

      .toggle-live{
        margin-left: 24px;
      }
    }

    .text-entry-field-wrapper{
      .text-entry-title{
        color: @black-3;
        font-size: 12px;
        line-height: 28px;
        text-transform: capitalize;
      }

      .text-input {
        height: 32px;
        width: 100%;
        border: 1px solid #B9B9B9;
        border-radius: 4px;
        padding: 4px 8px;

        &::placeholder {
          font-size: 12px;
          color: @grey-12;
        }
      }
    }

    .scheduler-config {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 32px;
    }

    .align-inline {
      display: inline-block;
    }

    .textarea-wrapper {
      height: 140px;
      border: 1px solid #B9B9B9;
      border-radius: 4px;
    }

    .multiselect__tags {
      font-size: 12px;
    }
  }

  .title {
    color: @black-3;
    font-family: "Open Sans", sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 24px;
    text-transform: none;
  }

  .group-btn {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 40px;
  }

  .isLoading {
    display: block;
    text-align: center;
    color: #606060;
    height: 100%;
  }

  .noDisplay {
    display: none!important;
  }

  .overlay {
    position: relative;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    cursor: pointer;
  }

  .spinner-align {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .image-preview {
    width: 350px;
    height: auto;
    margin-bottom: 15px;
    .preview {
      max-width: 100%;
      max-height: 200px;
    }
  }

  .loading-btn {
    width: 15px;
  }

  .email-head-text {
    color: #424242;
    font-family: @font-family-main;
    font-weight: bold;
    font-size: 16px;
    line-height: 32px;
    margin-top: 20px;
  }

  .alert-icon-red-error {
    width: 24px;
    height: 24px;
    color: @white;
    background: @white url('../../../static/img/icon-field-error-red-boder.svg') no-repeat center;
  }

  .display-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }
  .display-flex-end{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .error-text-color {
    color: #FF3400;
    font-family: "Open Sans",serif;
    font-size: 12px;
    line-height: 16px;
    margin-left: 8px;
  }

  .branded-url-error {
    display: flex;
    align-items: center;
  }

  .sf-program-id-error {
    display: flex;
    align-items: center;
  }
}


</style>



// WEBPACK FOOTER //
// ConfigureSchedulerModal.vue?30a7103b